'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmMicrophone } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm';
import style from './page-dictate.module.scss';

export const PageDictate: React.FC = () => {
  const label = useLabel();
  const { recognizeStart, recognizeStop, hasSpeechRecognitionSupport } = useLlm(state => state.actions);
  const hasSpeechRecognition = hasSpeechRecognitionSupport();
  return hasSpeechRecognition && (
    <button type="button" className={getClassNames(style.dictate)}
      aria-label={label('llm.dictate')}
      onMouseDown={() => recognizeStart()}
      onMouseUp={() => recognizeStop()}
      onTouchStart={() => recognizeStart()}
      onTouchEnd={() => recognizeStop()}
    >
      <IconLlmMicrophone />
    </button>
  );
};
